/**
 * Returns a string representation for the provided code.
 *
 * @param from - Gender code
 */
export default function genderString(from: string): string {
  switch (from) {
    case 'M':
      return 'Masculino';
    case 'F':
      return 'Femenino';
    default:
      return 'Otro';
  }
}
